import { useEffect, useMemo, useState } from "react";
import { IRCAUsersDropdown } from "./RCAUsersDropdownInterfaces";
import { useStyles } from "./RCAUsersDropdown.styles";
import { UsersEntity } from "entities/Users/UsersEntity";
import NewMainSelect from "components/NewMainSelect/NewMainSelect.view";
import { useTranslation } from "react-i18next";
import { ASSIGNABLE_USER_TYPE_IDS } from "constants/constants";

const RCAUsersDropdown = ({
    value,
    onChange,
    multiple,
    handleOnComponentMount,
    name,
    className,
    fullWidth,
    placeholder,
    customOptions,
    disabled,
    millId,
}: IRCAUsersDropdown) => {
    const { users } = UsersEntity.GetAllUsers(ASSIGNABLE_USER_TYPE_IDS, millId);
    const classes = useStyles();
    const { t } = useTranslation();
    const [startupStatusAssignedSetted, setStartupStatusAssignedSetted] = useState(false);

    const ordererMeomizedUsers = useMemo(() => {
        const currentUserList = [...users];
        if (currentUserList && currentUserList.length > 0) {
            return currentUserList.sort((a, b) => {
                if (a.first_name.toLowerCase() < b.first_name.toLowerCase()) {
                    return -1;
                }
                if (a.first_name.toLowerCase() > b.first_name.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
        }
        return [];
    }, [users]);

    const ownersOptions = useMemo(() => {
        if (ordererMeomizedUsers) {
            const usersList = ordererMeomizedUsers.map((user) => {
                return {
                    id: user.user_id.toString(),
                    name: `${user.first_name} ${user.last_name}`,
                    picture: user.media?.media_url || "",
                };
            });

            return usersList;
        }
        return [];
    }, [ordererMeomizedUsers]);

    useEffect(() => {
        if (multiple && ownersOptions.length > 0 && !startupStatusAssignedSetted) {
            if (handleOnComponentMount) handleOnComponentMount([...ownersOptions.map((option) => option.id)]);
            setStartupStatusAssignedSetted(true);
        }
    }, [multiple, startupStatusAssignedSetted, handleOnComponentMount, ownersOptions]);

    if (multiple) {
        return (
            <NewMainSelect
                name={name}
                fullWidth={false}
                disableMenuPropsStyles
                disabled={disabled}
                multiple
                className={`${classes.select} ${className || ""} ${fullWidth ? classes.fullWidth : ""}`}
                options={customOptions || ownersOptions}
                value={value}
                onChange={(selected) => {
                    onChange(selected);
                }}
                placeholder={placeholder || t("rca.user_select.select_user")}
                withSearchBar
                withAvatar
            />
        );
    }

    return (
        <NewMainSelect
            fullWidth={false}
            disableMenuPropsStyles
            disabled={disabled}
            multiple={false}
            withSearchBar
            className={`${classes.select} ${className || ""} ${fullWidth ? classes.fullWidth : ""}`}
            options={customOptions || ownersOptions}
            name={name}
            value={value}
            onChange={(selected) => {
                onChange(selected);
            }}
            placeholder={placeholder || t("rca.user_select.select_user")}
            withAvatar
        />
    );
};

export default RCAUsersDropdown;
